const registerGoogleMap = () => {
	// Declare map
	const googleMap = document.querySelectorAll('#map');

	// Google Maps
	googleMap.forEach((element) => {
		function createMap(el, lat, long, zoom, marker) {
			// Set a center point of the map, can be re-evaluated using `centerMap()`
			const center = { lat: lat, lng: long };

			const mapOptions = {
				zoom: zoom,
				center: center,
				fullscreenControl: false,
			};

			// Create a map instance.
			const melonMap = new google.maps.Map(document.getElementById(el), mapOptions);

			// Marker locations [name, lat, long, zindex]
			const markerLocation = [['AJM Choice', lat, long, 1]];

			if (marker == true) {
				markerLocation.forEach((markerLocation) => {
					const title = markerLocation[0];

					const location = {
						lat: parseFloat(markerLocation[1]),
						lng: parseFloat(markerLocation[2]),
					}

					new google.maps.Marker({
						position: location,
						map: melonMap,
						title: title,
					});
				});
			}

			// Add map style
			melonMap.setOptions({
				styles: [
					{ featureType: "water", elementType: "geometry", stylers: [{ color: "#e9e9e9" }, { lightness: 17 }] },
					{ featureType: "landscape", elementType: "geometry", stylers: [{ color: "#f5f5f5" }, { lightness: 20 }] },
					{ featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#ffffff" }, { lightness: 17 }] },
					{ featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }] },
					{ featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#ffffff" }, { lightness: 18 }] },
					{ featureType: "road.local", elementType: "geometry", stylers: [{ color: "#ffffff" }, { lightness: 16 }] },
					{ featureType: "poi", elementType: "geometry", stylers: [{ color: "#f5f5f5" }, { lightness: 21 }] },
					{ featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#dedede" }, { lightness: 21 }] },
					{ elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#ffffff" }, { lightness: 16 }] },
					{ elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }] },
					{ elementType: "labels.icon", stylers: [{ visibility: "off" }] },
					{ featureType: "transit", elementType: "geometry", stylers: [{ color: "#f2f2f2" }, { lightness: 19 }] },
					{ featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#fefefe" }, { lightness: 20 }] },
					{ featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }] }
				]
			});
		}

		// Initiate google map for contact form
		createMap('map', 52.05620535634401, -0.7708569137839868, 14, true);
	});
}


// Identify the device as touch device
function hasTouch() {
	return 'ontouchstart' in document.documentElement
		|| navigator.maxTouchPoints > 0
		|| navigator.msMaxTouchPoints > 0;
}

// Hack to remove all hover effects on touch devices
if (hasTouch()) { // remove all :hover stylesheets
	try { // prevent exception on browsers not supporting DOM styleSheets properly
		for (var si in document.styleSheets) {
			var styleSheet = document.styleSheets[si];
			if (!styleSheet.rules) continue;

			for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
				if (!styleSheet.rules[ri].selectorText) continue;

				if (styleSheet.rules[ri].selectorText.match('btn:hover')) {
					styleSheet.deleteRule(ri);
				}
			}
		}
	} catch (ex) { }
}

document.addEventListener('DOMContentLoaded', () => {
	registerGoogleMap();

	const body = document.querySelector('body');

	// Helper function
	let domReady = (cb) => {
		document.readyState === 'interactive' || document.readyState === 'complete'
			? cb()
			: document.addEventListener('DOMContentLoaded', cb);
	};

	domReady(() => {
		// Display body when DOM is loaded
		body.style.visibility = 'visible';
	});

	// Google Recaptcha v3
	grecaptcha.ready(function () {
		document.querySelectorAll('form.mod-recaptcha').forEach((element) => {
			// TODO: replace key with project one - this one is a Codename framework key
			grecaptcha.execute('6Le3scIZAAAAAOT2o50REZN2_JuOFanbYKkUz-de', { action: 'submit' }).then(function (token) {
				$('<input>').attr({
					type: 'hidden',
					name: 'g-recaptcha-response',
					value: token
				}).appendTo(element)
			});
		});
	});

	// hide cookie policy
	document.querySelector('.section-cookies .btn-accept').addEventListener('click', (e) => {
		e.preventDefault();

		// If no validation errors
		$.ajax({
			method: "POST",
			url: "api/cookies/",
			data: {
				'cookies-accepted': 1,
			}
		}).done(function () {
			$('.section-cookies').addClass('mod-hide').removeClass('show');
		});
	});

	document.querySelector('.section-cookies .btn-decline').addEventListener('click', (e) => {
		e.preventDefault();

		$.ajax({
			method: "POST",
			url: "api/cookies/",
			data: {
				'cookies-accepted': 0,
			}
		}).done(function () {
			$('.section-cookies').addClass('mod-hide').removeClass('show');
		});
	});

	// Add class to inputs when clicked on add effect
	const form = document.querySelectorAll('form');

	if (form) {
		document.querySelectorAll('form input, form textarea').forEach((element) => {
			element.addEventListener('focus', () => {
				element.parentElement.classList.add('mod-filled');
			});

			element.addEventListener('blur', () => {
				if (element.value) {
					element.parentElement.classList.add('mod-filled');
				} else {
					element.parentElement.classList.remove('mod-filled');
				}
			});
		});
	}

	const contactPage = document.querySelectorAll('#contact'),
		contactForm = document.querySelector('#contactForm');

	if (contactPage) {

		if (contactForm) {
			// Ajax contact form processing
			contactForm.addEventListener('submit', function (event) {
				event.preventDefault();

				const spamField = document.querySelectorAll('input#Form_Email'),
					loadingSpinner = document.querySelectorAll('.section-form .loading');

				// if honeypot field is filled in by spambot, do not submit
				if (spamField[0].value) {
					return false;
				}

				loadingSpinner[0].classList.add('mod-show');

				$.ajax({
					method: 'POST',
					url: 'process/contact/',
					dataType: 'json',
					data: $(this).serialize()
				}).done(function (response) {
					// If no errors
					if (response == 'success') {
						loadingSpinner[0].classList.remove('mod-show');

						// Remove filled class on inputs
						document.querySelectorAll('#contactForm .form-element').forEach((element) => {
							element.classList.remove('mod-filled');
						});

						// Hide form temporarily
						contactForm.classList.add('mod-hide');

						// Show thank you message
						contactForm.nextElementSibling.classList.add('mod-show');

						// Remove any errors that may still be there
						contactForm.firstElementChild.innerHTML = '';

						// Remove any values in inputs that would be still in there after submission
						document.querySelectorAll('#contactForm .form-element input, #contactForm .form-element textarea').forEach((element) => {
							element.value = '';
						});

						// Empty all error texts
						document.querySelectorAll('#contact .sub-error').forEach((element) => {
							element.innerHTML = '';
						});

						// Remove error class
						document.querySelectorAll('#contactForm .form-element').forEach((element) => {
							element.classList.remove('mod-error');
						});

						// Hide thank you message after 10 seconds and return to form
						setTimeout(function () {
							contactForm.classList.remove('mod-hide');
							contactForm.nextElementSibling.classList.remove('mod-show');
						}, 10000);

					}
					else {
						loadingSpinner[0].classList.remove('mod-show');

						contactForm.firstElementChild.innerHTML = 'Please fix the errors below:';

						// Empty any error messages that don't need it
						document.querySelectorAll('#contactForm .sub-error').forEach((element) => {
							element.innerHTML = '';
						});

						// Remove error class
						document.querySelectorAll('#contactForm .form-element').forEach((element) => {
							element.classList.remove('mod-error');
						});

						for (const [key, value] of Object.entries(response)) {
							if (key) {
								// Implement error message to specific input that needs it
								document.querySelectorAll('#contactForm .sub-error[data-error="' + key + '"]')[0].innerHTML = response[key]['message'];

								// Add error class to form element for styling
								if (key !== 'recaptcha') {
									document.querySelectorAll('#contactForm .form-element.mod-' + key)[0].classList.add('mod-error');
								}
							}
						}
					}
				});
			});
		}
	}

	const homePage = document.querySelectorAll('#home'),
		homeForm = document.querySelector('#homeForm');

	if (homePage) {

		if (homeForm) {
			// Ajax contact form processing
			homeForm.addEventListener('submit', function (event) {
				event.preventDefault();

				const spamField = document.querySelectorAll('input#Form_Email'),
					loadingSpinner = document.querySelectorAll('.section-contact-form .loading');

				// if honeypot field is filled in by spambot, do not submit
				if (spamField[0].value) {
					return false;
				}

				loadingSpinner[0].classList.add('mod-show');

				$.ajax({
					method: 'POST',
					url: 'process/homeForm/',
					dataType: 'json',
					data: $(this).serialize()
				}).done(function (response) {
					// If no errors
					if (response == 'success') {
						loadingSpinner[0].classList.remove('mod-show');

						// Remove filled class on inputs
						document.querySelectorAll('#homeForm .form-element').forEach((element) => {
							element.classList.remove('mod-filled');
						});

						// Hide form temporarily
						homeForm.classList.add('mod-hide');

						// Show thank you message
						homeForm.nextElementSibling.classList.add('mod-show');

						// Remove any errors that may still be there
						homeForm.firstElementChild.innerHTML = '';

						// Remove any values in inputs that would be still in there after submission
						document.querySelectorAll('#homeForm .form-element input, #homeForm .form-element textarea').forEach((element) => {
							element.value = '';
						});

						// Empty all error texts
						document.querySelectorAll('#homeForm .sub-error').forEach((element) => {
							element.innerHTML = '';
						});

						// Remove error class
						document.querySelectorAll('#homeForm .form-element').forEach((element) => {
							element.classList.remove('mod-error');
						});

						// Hide thank you message after 10 seconds and return to form
						setTimeout(function () {
							homeForm.classList.remove('mod-hide');
							homeForm.nextElementSibling.classList.remove('mod-show');
						}, 10000);

					}
					else {
						loadingSpinner[0].classList.remove('mod-show');

						homeForm.firstElementChild.innerHTML = 'Please fix the errors below:';

						// Empty any error messages that don't need it
						document.querySelectorAll('#homeForm .sub-error').forEach((element) => {
							element.innerHTML = '';
						});

						// Remove error class
						document.querySelectorAll('#homeForm .form-element').forEach((element) => {
							element.classList.remove('mod-error');
						});

						for (const [key, value] of Object.entries(response)) {
							if (key) {
								// Implement error message to specific input that needs it
								document.querySelectorAll('#homeForm .sub-error[data-error="' + key + '"]')[0].innerHTML = response[key]['message'];

								// Add error class to form element for styling
								if (key !== 'recaptcha') {
									document.querySelectorAll('#homeForm .form-element.mod-' + key)[0].classList.add('mod-error');
								}
							}
						}
					}
				});
			});
		}
	}

	// Hamburger menu function
	document.querySelectorAll('.mob-hamburger').forEach((hamburger) => {
		hamburger.addEventListener('click', (e) => {
			e.preventDefault();

			// Add active class to hamburger so it can be animated
			hamburger.classList.toggle('mod-active');

			hamburger.setAttribute('aria-label', 'Close menu');

			// Add active class to nav to show
			document.querySelector('#nav.mod-mobile').classList.toggle('mod-show');

			// Add no scroll class to body and html to prevent scrolling when nav is active
			body.classList.toggle('no-scroll');
			document.documentElement.classList.toggle('no-scroll');

			// Add active class to header
			document.querySelector('.header-main').classList.toggle('mod-active');

			// Add active class on all li's
			if (!hamburger.classList.contains('mod-active')) {
				hamburger.setAttribute('aria-label', 'Open menu');

				document.querySelectorAll('#nav.mod-mobile ul li').forEach((element) => {
					element.classList.remove('mod-show');
				});

				setTimeout(function () {
					document.querySelector('#nav.mod-mobile').classList.remove('mod-show');
				}, 550);
			} else {
				setTimeout(function () {
					document.querySelectorAll('#nav.mod-mobile ul li').forEach((element) => {
						element.classList.add('mod-show');
					});
				}, 900);
			}
		});
	});

	// Sub menu - mobile

	document.querySelectorAll('nav.mod-mobile .list-nav li.mod-sub-nav > a').forEach((dropdown) => {
		dropdown.addEventListener('click', (e) => {
			e.preventDefault();

			dropdown.classList.toggle('mod-active');
		});
	});


	// SLICK JS BITS

	if ($('.cards.js-slick').length) {
		$('.cards.js-slick').slick({
			accessibility: true,
			arrows: true,
			autoplay: false,
			draggable: false,
			dots: false,
			infinite: false,
			slidesToScroll: 3,
			slidesToShow: 3,
			speed: 400,
			prevArrow: $('.nav-slider .prev'),
			nextArrow: $('.nav-slider .next'),
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToScroll: 2,
						slidesToShow: 2,
						draggable: true
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToScroll: 1,
						slidesToShow: 1,
						draggable: true
					}
				}
			]
		});
	}

	if ($('.carousel').length) {
		$('.carousel').slick({
			accessibility: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 6000,
			draggable: true,
			fade: true,
			dots: true,
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 1,
		});
	}

	if ($('.list-testimonials').length) {
		var $slider = $('.list-testimonials');

		$slider.on('init', function(event, slick) {
		  if (slick.slideCount <= 1) {
			$slider.find('.slick-dots').hide();
		  }
		});
		
		$slider.slick({
			adaptiveHeight: true,
			accessibility: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 10000,
			draggable: true,
			fade: true,
			dots: true,
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			asNavFor: $('.section-quote-testimonials .image')
		});
	}

	if ($('.section-quote-testimonials').length) {
		$('.section-quote-testimonials .image').slick({
			accessibility: false,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 10000,
			draggable: true,
			fade: true,
			dots: false,
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			asNavFor: $('.list-testimonials')
		});
	}

	if ($('#news-post').length) {
		const newsStoryCarousel = $('.carousel-images-wrap');

		newsStoryCarousel.slick({
			autoplay: true,
			autoplaySpeed: 5000,
			dots: true,
			arrows: false
		});

		const slideCount = newsStoryCarousel.find('.slick-slide:not(.slick-cloned)').length;
		const dotWidth = 100 / slideCount;
		const dots = newsStoryCarousel.find('.slick-dots li.slick-active');

		// Set with of each li so that they equally fill up the carousel's width (e.g. 3 slides would have 33% width).
		dots.css('width', dotWidth + '%');

		// Create clones that will always be visible (and grey).
		dots.find('button').each(function () {
			const clonedDot = $(this).clone();

			clonedDot.addClass('js-clone');

			$(this).parent().append(clonedDot);
		});

		// Iterate over each (green) non-clone and animate its width from 0% to 100%.
		function animateButton(i, slideCount, delay) {
			const button = dots.eq(i).find('button:not(.js-clone)');

			button.animate({ width: '100%' }, delay, () => {
				button.css('width', 0);

				newsStoryCarousel.slick('slickGoTo', i, false);
			});

			++i;

			if (i === slideCount) {
				i = 0;
			}

			setTimeout(() => animateButton(i, slideCount, delay), delay);
		}

		// Pass all relevant data to the function itself to keep it pure (rather than relying on global state).
		animateButton(0, slideCount, 5000);
	}

	// Accordion
	const accordion = document.querySelectorAll('#accordion');

	if (accordion) {
		// Define variables
		var accordionLabels = document.querySelectorAll("#accordion .accordion-item");

		// Listen for click on the document
		function activateAccordion(event) {
			// If the Tab key is hit or a mouse click occurs then run the code
			if (event.type == 'click' || event.keyCode == '9') {
				// Bail if our clicked element doesn't have the class
				if (!event.target.classList.contains('item-accordion')) return;

				// Get the target content
				var content = document.querySelector(event.target.getAttribute('data-link'));
				if (!content) return;

				// Prevent default link behavior
				event.preventDefault();

				// Add active class to accordian item link
				event.target.classList.add('active');
				event.target.setAttribute('aria-expanded', 'true');

				// If the content is already expanded, collapse it and quit
				if (content.classList.contains('active')) {
					content.classList.remove('active');
					event.target.classList.remove('active');
					event.target.setAttribute('aria-expanded', 'false');
					return;
				}

				// Get all open accordion content, loop through it, and close it
				var accordions = document.querySelectorAll('.accordion-content.active');
				for (var i = 0; i < accordions.length; i++) {
					// Remove active class from content div
					accordions[i].classList.remove('active');

					// Remove active class from accordion item link
					accordions[i].previousElementSibling.children[0].classList.remove('active');
					accordions[i].previousElementSibling.children[0].setAttribute('aria-expanded', 'false');
				}

				// Toggle our content
				content.classList.toggle('active');
			}
		};

		// Apply event listeners
		accordionLabels.forEach(function (label, index) {
			label.addEventListener("click", activateAccordion);
			label.addEventListener("keyup", activateAccordion);
		});
	}
});